import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import ProfileService from "../../services/ProfileService";
import RechargeService from "../../services/RechargeService";
import BbpsService from "../../services/BbpsService";
import SideBar from "../../components/Sidebar";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";

const BillPaymentOrderSummary = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { category, logo, selectedOperator, paramsFields, billData, amount } =
    location.state || {};

  //const isPrepaid = type === "PREPAID";

  const [loading, setLoading] = useState(false);
  const [balanceData, setBalanceData] = useState();
  const [commercialData, setCommercialData] = useState();

  useEffect(() => {
    fetchBalance();
    getCommercialHandler();
  }, []);

  const fetchBalance = async () => {
    setLoading(true);
    try {
      const result = await ProfileService.fetchBalance();
      if (!result.success) {
        Swal.fire("Oops!", result.message, "error");
        return;
      }

      const responseData = result.data;

      if (responseData.status === "SUCCESS") {
        const data = responseData.data;
        setBalanceData(data);
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire("Oops!", "Request Failed: " + (error.message || ""), "error");
    } finally {
      setLoading(false);
    }
  };

  const getCommercialHandler = async () => {
    setLoading(true);
    try {
      const result = await RechargeService.getCommercial(
        "",
        selectedOperator.operator_id,
        amount,
        true
      );
      if (!result.success) {
        Swal.fire("Oops!", result.message, "error");
        return;
      }

      const responseData = result.data;

      if (responseData.status === "SUCCESS") {
        const data = responseData.data;
        setCommercialData(data);
      } else {
        Swal.fire("Oops!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire("Oops!", "Request Failed: " + (error.message || ""), "error");
    } finally {
      setLoading(false);
    }
  };

  const transactionHandler = async () => {
    setLoading(true);
    try {
      const result = await BbpsService.billPayment(
        selectedOperator.id,
        selectedOperator.operator_id,
        paramsFields,
        amount
      );
      if (!result.success) {
        Swal.fire("Oops!", result.message, "error");
        return;
      }

      const responseData = result.data;

      navigate("/bill-payment/order-confirmation", {
        state: {
          category,
          logo,
          selectedOperator,
          paramsFields,
          billData,
          amount,
          commercialData,
          responseData,
        },
      });
    } catch (error) {
      Swal.fire("Oops!", "Request Failed: " + (error.message || ""), "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-4">
      {loading && <LoadingScreen />}

      <div className="row">
        {/* Sidebar */}
        <SideBar />

        {/* Main Content */}
        <div className="col-md-9 mb-5">
          <div
            className="card p-4 shadow-sm"
            style={{ minHeight: "80vh", backgroundColor: "#f8f9fa" }}
          >
            <h4 className="text-center fw-bold mb-4">Bill Payment Summary</h4>

            <div className="d-flex justify-content-center ">
              <div
                className="card p-4 shadow-sm"
                style={{
                  maxWidth: "530px",
                  width: "100%",
                  borderRadius: "16px",
                  backgroundColor: "#ffffff",
                }}
              >
                <div className="pb-2 text-center">
                  <img
                    src="/assets/images/b_white_logo.png"
                    alt="b-logo"
                    width={70}
                  />
                </div>

                {/* {JSON.stringify(selectedOperator)} */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div>
                    <h5 className="mb-0">
                      {selectedOperator?.operator_name || "Operator"}
                    </h5>
                    <small className="text-muted">{category || "N/A"}</small>
                  </div>
                  <div className="d-flex align-items-center">
                    {logo && (
                      <img
                        src={logo}
                        alt={selectedOperator?.operator_name}
                        style={{
                          width: "60px",
                          height: "60px",
                          objectFit: "contain",
                        }}
                      />
                    )}
                  </div>
                </div>

                <ul className="list-group list-group-flush mb-3">
                  {billData.customer_id && (
                    <li className="list-group-item d-flex justify-content-between">
                      <span className="text-secondary">Customer Name</span>
                      <span className="fw-bold fs-6">
                        {billData?.customer_id || "N/A"}
                      </span>
                    </li>
                  )}

                  <li className="list-group-item d-flex justify-content-between">
                    <span className="text-secondary">Bill Number</span>
                    <span className="fw-bold fs-6">
                      {billData?.customer_ref_id || "N/A"}
                    </span>
                  </li>

                  <li className="list-group-item d-flex justify-content-between">
                    <span className="text-secondary">Bill Date</span>
                    <span className="fw-bold fs-6">
                      {billData?.bill_date || "N/A"}
                    </span>
                  </li>

                  <li className="list-group-item d-flex justify-content-between">
                    <span className="text-secondary">Due Date</span>
                    <span className="fw-bold fs-6">
                      {billData?.due_date || "N/A"}
                    </span>
                  </li>

                  <li className="list-group-item d-flex justify-content-between">
                    <span className="text-secondary">Bill Amount</span>
                    <span className="fw-bold fs-6">
                      ₹{billData?.bill_amount || "N/A"}
                    </span>
                  </li>

                  <li className="list-group-item d-flex justify-content-between">
                    <span className="text-secondary">Bill Net Amount</span>
                    <span className="fw-bold fs-6">
                      ₹{billData?.bill_net_amount || "N/A"}
                    </span>
                  </li>

                  {billData?.accept_part_pay && (
                    <li className="list-group-item d-flex justify-content-between">
                      <span className="text-secondary">Paying Amount</span>
                      <span className="fw-bold fs-6">₹{amount || "N/A"}</span>
                    </li>
                  )}
                </ul>

                {balanceData && (
                  <div className="text-center mb-2">
                    <h6>
                      Available Balance:{" "}
                      <span className="fw-bold text-success">
                        ₹{balanceData?.main_wallet || "0.00"}
                      </span>
                    </h6>
                  </div>
                )}

                {/* Highlighted Payment Section */}
                <div
                  className="p-3 rounded mb-3"
                  style={{
                    backgroundColor: "#f1f3f5",
                    border: "1px solid #ced4da",
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "1rem",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  {/* Discount block or spacer */}
                  {commercialData && commercialData.commercial_amount > 0 ? (
                    <div
                      className="d-flex align-items-center"
                      style={{
                        backgroundColor: "#e6f4ea",
                        border: "1px solid #a3d3a1",
                        padding: "0.5rem 1rem",
                        borderRadius: "8px",
                        color: "#2f7a32",
                        fontWeight: "600",
                        fontSize: "0.95rem",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-tag-fill me-2"
                        viewBox="0 0 16 16"
                        style={{ marginRight: "0.5rem" }}
                      >
                        <path d="M2 2a1 1 0 0 0-1 1v3.586a1 1 0 0 0 .293.707l6 6a1 1 0 0 0 1.414 0l3.586-3.586a1 1 0 0 0 0-1.414l-6-6A1 1 0 0 0 5.586 2H2z" />
                        <path d="M5.5 5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z" />
                      </svg>
                      Discount: ₹{commercialData.commercial_amount}
                    </div>
                  ) : (
                    <div style={{ flex: 1 }} /> // Empty spacer to keep alignment
                  )}

                  {/* Payable Amount */}
                  <div
                    className="fw-bold text-primary"
                    style={{ minWidth: "150px", textAlign: "right" }}
                  >
                    <span style={{ fontSize: "16px" }}>Payable Amount:</span>{" "}
                    <span style={{ fontSize: "17px" }}>
                      ₹
                      {commercialData
                        ? commercialData.payable_amount
                        : billData?.bill_net_amount}
                    </span>
                  </div>
                </div>

                <button
                  className="btn btn-primary w-100 py-2 fs-6"
                  onClick={transactionHandler}
                >
                  Make Payment
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillPaymentOrderSummary;
